<template>
	<div class="mobfooter_wrap">
		<div class="mobfooter_cont">
			<div class="mobfooter_title">Pla Pla</div>
			<div class="mobfooter_list">
				<div class="mobfooter_items scale-1px-home" @click="gotoPrivacy">
					<div class="mobfooter_ileft" :class="isPrivacy ? 'mobfooter_ileft_active' : ''">Aviso de Privacidad</div>
					<div class="mobfooter_iright">
						<img src="@/assets/mobimg/mobfooter_arrow.png" />
					</div>
				</div>
				<div class="mobfooter_items scale-1px-home" @click="gotoProvision">
					<div class="mobfooter_ileft" :class="isProvision ? 'mobfooter_ileft_active' : ''">Términos y Condiciones</div>
					<div class="mobfooter_iright">
						<img src="@/assets/mobimg/mobfooter_arrow.png" />
					</div>
				</div>
			</div>
			<!--<div class="mobfooter_middle">
				<div class="mobfooter_title">Sitios de referencia</div>
				<div class="mobfooter_mimg">
					<img src="@/assets/mobimg/mobfooter_logo.png" />
				</div>
			</div>-->
			<div class="mobfooter_down">
				<div class="mobfooter_title">Contáctanos</div>
				<div class="mobfooter_dlist">
					<div class="mobfooter_dlitem">Atención al clientes：(55) 8526-6878</div>
					<div class="mobfooter_dlitem">Atención al clientes：5646391950</div>
					<div class="mobfooter_dlitem">Correo electrónico：plaplaprestamos@gmail.com</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mobfooter',
		data() {
			return {
				isPrivacy: false,
				isProvision: false,
			}
		},
		created() {},
		mounted() {
			let usePath = this.$route.path

			if (usePath.indexOf('privacy') != -1) {
				this.isPrivacy = true
			} else {
				this.isPrivacy = false
			}

			if (usePath.indexOf('provision') != -1) {
				this.isProvision = true
			} else {
				this.isProvision = false
			}
		},
		methods: {
			gotoPrivacy() {
				this.$router.push({
					path: '/privacy',
				})
			},
			gotoProvision() {
				this.$router.push({
					path: '/provision',
				})
			},
		},
	}
</script>

<style></style>
